import React from "react";
import styled from "@emotion/styled";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export const Input = styled(TextField)`
	background: transparent;
	color: #090b0f;
	border-radius: 4px;
	text-align: left;

	.MuiFilledInput-root {
		background: transparent;
	}

	.MuiInputLabel-root,
	.MuiInputLabel-root.Mui-focused {
		color: #a3a3a3;
	}

	.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
		border-color: var(--primaryColor);
	}

	.MuiFilledInput-root::before,
	.MuiFilledInput-root::after {
		border-radius: 3px;
	}

	.MuiFilledInput-root::after {
		border-color: #a3a3a3;
	}
`;

Input.defaultProps = {
	variant: "outlined",
	fullWidth: true,
};

export const SearchInput = styled(Input)`
	width: 335px;
	margin-bottom: 10px;
	color: #ffffff;

	label {
		color: #ffffff !important;
	}

	fieldset {
		border-color: #21cfdc !important;
	}

	svg {
		fill: #ffffff;
	}
`;

SearchInput.defaultProps = {
	InputProps: {
		endAdornment: (
			<InputAdornment position="end">
				<IconButton edge="end">
					<SearchIcon />
				</IconButton>
			</InputAdornment>
		),
	},
};
